import DesignTool from "./designtool";
import Utils from "./utils";

class EaringItem {
  constructor(
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    angle
  ) {
    this.sizeID = sizeID;
    this.imageURL = imageDesign;
    this.size = size;
    this.angle = angle;
    this.productID = productID;
    this.productType = productType;
    this.imageSize = imageSize > 0 ? imageSize : null;
    let sizes = this._calculateSizes(this.imageSize);
    this.scale = sizes.scale;
    this.posY = 0;
  }

  updateSizes(imageWidth, imageHeight) {
    this.imageSize = imageWidth;
    let sizes = this._calculateSizes(imageWidth, imageHeight);
    this.scale = sizes.scale;
  }

  updatePos(center) {
    let x = this.circleRadius * Math.cos(this.angle);
    let y = this.circleRadius * Math.sin(this.angle);
    this.pos = { x: center.x + x, y: center.y + y };
    if (this.img) {
      this.img
        .set({
          left: this.pos.x,
          top: this.pos.y
        })
        .setCoords();
    }
  }

  setPos(x, y) {
    if (this.img) {
      this.img
        .set({
          left: x,
          top: y
        })
        .setCoords();
    }
  }

  _calculateSizes(_imageWidth, _imageHeight) {
    var imageSize = _imageWidth || 108;
    var imageHeight = _imageHeight || 108;
    var displaySize = 0;
    if (this.productType === 1) {
      displaySize =
        DesignTool.unitRatio * this.size * (imageSize / imageHeight);
    } else {
      imageSize = _imageWidth || 100;
      displaySize = DesignTool.unitRatio * this.size;
    }

    return {
      displaySize: displaySize,
      imageSize: imageSize,
      scale: displaySize / imageSize
    };
  }
}

export default EaringItem;
